///<reference path="./typings/browser.d.ts" />
'use strict'

type Promise<T> = angular.IPromise<T>

export interface RouteDefinition {
    path: string;
    component: string;
    name: string;
    useAsDefault?:boolean;
}

export interface IRoutingComponent {
    /**
     * called to to determine whether a Component can be reused across Route Definitions that match the same type of Component, or whether to destroy and instantiate a new Component every time.
     */
    $routerCanReuse?(next?: angular.ComponentInstruction, prev?: angular.ComponentInstruction) : ng.IPromise<boolean> | boolean;
    /**
     * called by the Router at the end of a successful navigation. Only one of $routerOnActivate and $routerOnReuse will be called depending upon the result of a call to $routerCanReuse.
     */
    $routerOnActivate?(next?: angular.ComponentInstruction, prev?: angular.ComponentInstruction) : ng.IPromise<any> | any;
    /**
     * called by the Router at the end of a successful navigation. Only one of $routerOnActivate and $routerOnReuse will be called depending upon the result of a call to $routerCanReuse.
     */
    $routeOnReuse?(next?: angular.ComponentInstruction, prev?: angular.ComponentInstruction) : ng.IPromise<any> | any;
    /**
     * called by the Router to determine if a Component can be removed as part of a navigation.
     */
    $routerCanDeactivate?(next?: angular.ComponentInstruction, prev?: angular.ComponentInstruction) : ng.IPromise<boolean> | boolean;
    /**
     * called by the Router before destroying a Component as part of a navigation.
     */
    $routerOnDeactivate?(next?: angular.ComponentInstruction, prev?: angular.ComponentInstruction) : ng.IPromise<any> | any;
}

export function RootRouterComponent(module: angular.IModule, selector: string) {
    return <TFunction extends Function>(target: TFunction) => {
        module.value("$routerRootComponent", selector);
        return target;
    };
}

export function RouteConfig(config: RouteDefinition[]): ClassDecorator {
    return <TFunction extends Function>(target: TFunction) => {
        target['$routeConfig'] = config;
        return target;
    };
}